import { gql } from "@apollo/client";

const GET_CURRENCY = gql`
  query {
    getAllCurrency {
      error
      status
      data {
        code
        name
        symbol
      }
    }
  }
`;

export default GET_CURRENCY;
